class ManualPortal {
	id = null;
	name = '';

	constructor(data) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}
	}
}

export default ManualPortal;
